import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["uploadType", "loading", "onChange", "testId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { useMemo } from 'react';
import { PhotoIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { Spinner, Title } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Upload = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var uploadType = _ref.uploadType,
      loading = _ref.loading,
      onChange = _ref.onChange,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, _excluded);

  var mappedItem = useMemo(function () {
    return uploadObject[uploadType];
  }, [uploadType]);
  var uploadExtensionType = useMemo(function () {
    return mappedItem['extension'];
  }, [mappedItem]);
  var uploadText = useMemo(function () {
    return mappedItem['text'];
  }, [mappedItem]);
  var uploadIcon = useMemo(function () {
    return mappedItem['icon'];
  }, [mappedItem]);
  var acceptedFormats = useMemo(function () {
    return typeof uploadExtensionType === 'string' ? uploadExtensionType : Array.isArray(uploadExtensionType) ? uploadExtensionType === null || uploadExtensionType === void 0 ? void 0 : uploadExtensionType.join(',') : AcceptedFileType.Pdf;
  }, [uploadExtensionType]);

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsxs(_StyledLabel, _objectSpread(_objectSpread({
      htmlFor: uploadType
    }, rest), {}, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv, {
        children: [uploadIcon, /*#__PURE__*/_jsxs(_StyledP, {
          children: [/*#__PURE__*/_jsx(_StyledSpan, {
            children: t('common:load')
          }), ' ', uploadText === 'video' ? t('common:one_of_yours') : t('common:your_own'), " ", uploadText]
        }), /*#__PURE__*/_jsx(Title, {
          content: "Max. File Size: 30MB",
          textColor: "black",
          fontSize: "xSmall",
          fontWeight: "semibold"
        })]
      }), /*#__PURE__*/_jsx(StyledUploadButton, {
        htmlFor: uploadType,
        loading: loading,
        "data-cy": testId,
        children: loading ? /*#__PURE__*/_jsx(Spinner, {
          size: "sm",
          color: "gray"
        }) : "".concat(t('common:load'), " ").concat(uploadText)
      }), /*#__PURE__*/_jsx(Input, {
        onChange: onChange,
        type: "file",
        id: uploadType,
        accept: acceptedFormats,
        hidden: true
      })]
    }))
  });
});
export default Upload;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "formupload__Wrapper",
  componentId: "sc-u1xy9m-0"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center"
});

var Input = /*#__PURE__*/_styled.input.withConfig({
  displayName: "formupload__Input",
  componentId: "sc-u1xy9m-1"
})({});

var StyledUploadButton = /*#__PURE__*/_styled.label.withConfig({
  displayName: "formupload__StyledUploadButton",
  componentId: "sc-u1xy9m-2"
})(["", " ", " ", " ", " ", ""], {
  "display": "inline-flex",
  "maxWidth": "28rem",
  "cursor": "pointer",
  "alignItems": "center"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
  ":focus": {
    "outline": "2px solid transparent",
    "outlineOffset": "2px",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
  }
}, {
  "borderRadius": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem"
}, {
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, function (_ref2) {
  var loading = _ref2.loading;
  return loading ? {
    "pointerEvents": "none"
  } : {};
}); // --> const


var AcceptedFileType = {
  Text: '.txt',
  Gif: '.gif',
  Jpeg: '.jpg',
  Png: '.png',
  Doc: '.doc',
  Pdf: '.pdf',
  AllImages: 'image/*',
  AllVideos: 'video/*',
  AllAudios: 'audio/*'
};
export var uploadObject = {
  picture: {
    icon: /*#__PURE__*/_jsx(PhotoIcon, {
      className: "h-8 w-8 text-primary-500"
    }),
    text: 'foto',
    extension: ['.jpg', '.jpeg', '.png']
  },
  video: {
    icon: /*#__PURE__*/_jsx(VideoCameraIcon, {
      className: "h-8 w-8 text-primary-500"
    }),
    text: 'video',
    extension: ['.mp4', '.mp4v', '.mov', '.ogv', '.webm']
  } // file: {
  //   icon: <img src={getAssetSrc('/utils-assets/cloud-upload.svg')} alt="" />,
  //   text: 'file',
  //   extension: ['.pdf', '.doc', '.docx'],
  // },

};

var _StyledLabel = /*#__PURE__*/_styled("label").withConfig({
  displayName: "formupload___StyledLabel",
  componentId: "sc-u1xy9m-3"
})({
  "display": "flex",
  "height": "17rem",
  "width": "100%",
  "maxWidth": "20rem",
  "cursor": "pointer",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1rem",
  "borderRadius": "16px",
  "borderWidth": "2px",
  "borderStyle": "dashed",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(142 105 206 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(226 216 243 / var(--tw-bg-opacity))"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formupload___StyledDiv",
  componentId: "sc-u1xy9m-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.25rem"
});

var _StyledP = /*#__PURE__*/_styled("p").withConfig({
  displayName: "formupload___StyledP",
  componentId: "sc-u1xy9m-5"
})({
  "marginBottom": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "formupload___StyledSpan",
  componentId: "sc-u1xy9m-6"
})({
  "fontWeight": "600"
});